export enum TABS {
  areas = 'areas',
  courses = 'courses',
  participants = 'participants',
}

export enum FiltersColumns {
  userState = 'user_active',
  areaName = 'name',
  courseName = 'courseName',
  profiles = 'profiles',
  requiredProfile = 'requiredProfile',
  optionalProfile = 'optionalProfile',
  userProfile = 'userProfile',
  stateAdvance = 'stateAdvance',
  finalState = 'finalState',
  startDate = 'startDate',
  endDate = 'endDate',
  finish = 'finish',
  inProgress = 'inProgress',
  pending = 'pending',
  provider = 'provider',
}
export const prefix = 'monitoring'
